import AuthTokenProvider from "./AuthTokenProvider";

async function parseError(response) {
    let detail = "";
    try {
        const contentType = response.headers.get("content-type") || "";
        detail = contentType.includes("application/json")
            ? JSON.stringify(await response.json())
            : await response.text();
    } catch {
        detail = "";
    }

    const error = new Error(`API ${response.status} ${response.statusText}`);
    error.status = response.status;
    error.detail = detail;
    return error;
}

async function request(url, { method = "GET", headers = {}, body = null, retryOn401 = true } = {}) {
    const token = await AuthTokenProvider.getAccessToken(false);

    let payload = body;
    const finalHeaders = { ...headers, Authorization: `Bearer ${token}` };

    const isJsonCandidate =
        body &&
        !(body instanceof FormData) &&
        typeof body !== "string" &&
        !(body instanceof Blob);

    if (isJsonCandidate) {
        payload = JSON.stringify(body);
        finalHeaders["Content-Type"] = finalHeaders["Content-Type"] || "application/json";
    }

    let response = await fetch(url, {
        method,
        headers: finalHeaders,
        body: payload
    });

    if (response.status === 401 && retryOn401) {
        const refreshed = await AuthTokenProvider.getAccessToken(true);
        response = await fetch(url, {
            method,
            headers: { ...finalHeaders, Authorization: `Bearer ${refreshed}` },
            body: payload
        });
    }

    if (!response.ok) {
        throw await parseError(response);
    }

    if (response.status === 204) return null;

    const contentType = response.headers.get("content-type") || "";
    return contentType.includes("application/json")
        ? response.json()
        : response.text();
}

const ApiClient = {
    get: (url, options) => request(url, { ...options, method: "GET" }),
    post: (url, body, options) => request(url, { ...options, method: "POST", body }),
    put: (url, body, options) => request(url, { ...options, method: "PUT", body }),
    patch: (url, body, options) => request(url, { ...options, method: "PATCH", body }),
    delete: (url, options) => request(url, { ...options, method: "DELETE" })
};

export default ApiClient;